module.exports = __webpack_public_path__ + "static/img/school-17.c282418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-17.png
// module id = BGA5
// module chunks = 1